import { createContext, useContext } from 'react';
import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';
import type { RawSession, SessionData, Account, SelectedAccount } from '@app-types';

export interface ChangeSelectedResidentOptions {
    ensureCommunitySubdomain?: boolean;
}

export interface SessionContextValue {
    rawSession: RawSession | null;
    session: SessionData | null;
    accounts: Account[];
    setSession: (session: RawSession | null) => void;
    selectedAccount: SelectedAccount | null;
    changeSelectedResident: (idAccount: number, navigate?: NavigateFunction, to?: To, options?: ChangeSelectedResidentOptions & NavigateOptions) => Promise<void>;
    logout: () => void;
}

const SessionContext = createContext<SessionContextValue | null>(null);

const useSessionContext = () => {
    const context = useContext(SessionContext);
    if (!context) {
        throw new Error(`useSessionContext must be used within a SessionProvider`);
    }
    return context;
};

export { SessionContext, useSessionContext };
